// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const customStyle = (
  isStoreDetailsDesktopRedesignEnabled,
  isStoreDetailsRedesignMobileEnabled,
  defaultOpen,
  props
) => {
  if (
    isStoreDetailsDesktopRedesignEnabled ||
    (isStoreDetailsRedesignMobileEnabled && defaultOpen)
  ) {
    return `border-bottom: 2px solid ${props.theme.colorPalette.gray[2000]};
    padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS};
    `;
  }
  if (isStoreDetailsRedesignMobileEnabled && !defaultOpen) {
    return `border-bottom: none;
    padding-bottom: 0;`;
  }
  return '';
};

export const collapsibleOverrideStyles = css`
  border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  ${(props) =>
    props.isStoreDetailsRedesignMobileEnabled &&
    `
  background-color: ${props.theme.colors.WHITE};
  `}
  ${(props) =>
    (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
    `
  padding:  ${props.theme.spacing.APP_LAYOUT_SPACING.XS};
  padding-top:  ${props.theme.spacing.ELEM_SPACING.REG};
  border: 1px solid ${props.theme.colors.BORDER.NORMAL};
  border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
  margin-bottom: ${!props.isHolidayHours && props.theme.spacing.APP_LAYOUT_SPACING.XS};
  `}
  .collapsible-header {
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    padding-top: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? 0
        : props.theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? props.theme.spacing.ELEM_SPACING.XS
        : props.theme.spacing.ELEM_SPACING.LRG};
    background: none;

    ${(props) =>
      customStyle(
        props.isStoreDetailsDesktopRedesignEnabled,
        props.isStoreDetailsRedesignMobileEnabled,
        props.defaultOpen,
        props
      )}

    > div {
      flex: 1;
      text-align: left;
    }
  }

  .collapsible-icon {
    top: 28px;
  }
  .data-list-wrapper-new {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .dsk-col {
    display: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      `flex`};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0;
    color: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.colorPalette.black};
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy4}px;
    line-height: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy5}px;
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.medium};
  }

  .current-date {
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  }
  .item-text {
    text-transform: lowercase;
    width: 30%;
    @media ${(props) => props.theme.mediaQuery.largeMax} {
      width: 25%;
    }
  }
  .item-text::first-letter {
    text-transform: uppercase;
  }
  .item-date {
    text-transform: capitalize;
    width: 30%;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) => !props.isHolidayHours && 'width: 25%;'}
    }
  }

  .item-date-holiday-hrs {
    text-transform: capitalize;
    width: 30%;
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.bold};
  }
  .header-text-status-open,
  .header-text-status,
  .header-text-status-body,
  .header-text-status-closed {
    display: inline-block;
    width: 30%;
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy5}px;
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.bold};
  }
  .header-text-status-closed {
    color: #e93223;
  }
  .header-text-status-open {
    color: ${(props) => props.theme.colors.GREEN};
  }
  .header-text-status {
    vertical-align: top;
  }
  .header-text-status-body {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .header-text-body {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  }
  .holiday-hrs-secondary-status {
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy5}px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }

  .header-text-secondary-status {
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy5}px;
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.normal};
  }
  .holiday-hrs-header {
    display: inline-block;
  }

  .holiday-hours-header-wrapper {
    display: flex;
  }

  .collapsible-header-text {
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.normal};
    color: ${(props) => props.theme.colorPalette.gray[4000]};
  }
`;

export default css`
  .data-list-wrapper {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.body.small.secondary}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    line-height: ${(props) => props.theme.fonts.lineHeight.normal};
    color: ${(props) => props.theme.colors.TEXT.DARK};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  .data-list {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }

  .text-left {
    flex: 1;
    text-align: left;
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    text-transform: capitalize;
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontWeight.semiBold};
    font-size: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled &&
      props.theme.fonts.fontSize.body.bodytext.copy4}px;
    font-size: ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled &&
      props.theme.fonts.fontSize.body.bodytext.copy3}px;
    color: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.colorPalette.gray[4000]};
  }

  .text-right {
    flex: 1;
    text-align: ${(props) => (props.isStoreDetailsDesktopRedesignEnabled ? 'left' : 'right')};
    text-align: ${(props) => props.isStoreDetailsRedesignMobileEnabled && 'left'};
    padding-left: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled
        ? '0'
        : props.theme.spacing.ELEM_SPACING.XXS};
    font-weight: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled && props.theme.fonts.fontWeight.extrabold};
    font-family: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) =>
      (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
      props.theme.fonts.fontSize.body.bodytext.copy4}px;
  }

  .store-hours-wrapper {
    padding: ${(props) =>
      `${props.theme.spacing.APP_LAYOUT_SPACING.XS} ${props.theme.spacing.ELEM_SPACING.REG}`};
    background-color: ${(props) => `${props.theme.colors.PRIMARY.PALEGRAY}`};
  }

  .meta {
    padding-top: ${(props) =>
      !props.isStoreDetailsDesktopRedesignEnabled && props.theme.spacing.ELEM_SPACING.XS};
    ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled &&
      `
   margin-left:${props.theme.spacing.ELEM_SPACING.REG};
   margin-right:${props.theme.spacing.ELEM_SPACING.REG};
   `}
    .data-list {
      ${(props) =>
        (props.isStoreDetailsDesktopRedesignEnabled || props.isStoreDetailsRedesignMobileEnabled) &&
        `display: flex;
        justify-content: space-between;
        `}
      > li:first-child {
        ${(props) =>
          (props.isStoreDetailsDesktopRedesignEnabled ||
            props.isStoreDetailsRedesignMobileEnabled) &&
          ` margin-right: 30px;
          border-right: 1px solid ${props.theme.colorPalette.gray[3800]};
            `}
      }
      .dsk-col {
        ${(props) =>
          (props.isStoreDetailsDesktopRedesignEnabled ||
            props.isStoreDetailsRedesignMobileEnabled) &&
          `display: flex;
          flex-direction: column;
          padding: ${props.theme.spacing.ELEM_SPACING.REG} 0;
          `}
      }
    }
  }
  .meta .text-right {
    text-align: ${(props) =>
      props.isStoreDetailsDesktopRedesignEnabled ||
      (props.isStoreDetailsRedesignMobileEnabled && `left`)};
    font-weight: ${(props) =>
      props.isStoreDetailsRedesignMobileEnabled && props.theme.fonts.fontWeight.bold};
  }
`;
